"use client"

/**
 * Trang Cố vấn có mở cho người đang đăng nhập không (sale newbie chưa được — lib/persona-access).
 * Một nguồn cho cổng route, menu và thẻ ở AI Agent Center; API của trang chặn lại ở server.
 */

import Link from "next/link"
import { queryOptions, useQuery } from "@tanstack/react-query"
import { LockSimpleIcon as Lock } from "@phosphor-icons/react/dist/csr/LockSimple"
import { useSession } from "@/lib/session-context"

export interface PersonaAccess {
  allowed: boolean
  reason: string | null
}

export const personaAccessQueryOptions = queryOptions({
  queryKey: ["persona-access"],
  queryFn: async (): Promise<PersonaAccess> => {
    const res = await fetch("/api/e2e/persona/access", { cache: "no-store" })
    // Không đọc được thì cho hiện (server vẫn chặn API) — đừng giấu trang vì một lỗi mạng.
    if (!res.ok) return { allowed: true, reason: null }
    return res.json()
  },
  staleTime: 5 * 60_000,
  retry: false,
})

/** false chỉ khi CHẮC người này chưa được vào (quản trị không hỏi). */
export function usePersonaPageAllowed(): boolean {
  const { isAdmin } = useSession()
  const access = useQuery({ ...personaAccessQueryOptions, enabled: !isAdmin })
  return isAdmin || access.data?.allowed !== false
}

export function PersonaAccessBlocked({ reason }: { reason: string }) {
  return (
    <div className="mx-auto flex min-h-[60dvh] max-w-md flex-col items-center justify-center gap-3 px-6 text-center">
      <span className="flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <Lock className="size-6" aria-hidden />
      </span>
      <h1 className="text-lg font-semibold text-foreground">Chưa mở trang Cố vấn</h1>
      <p className="text-sm text-muted-foreground">{reason}</p>
      <Link href="/" className="text-sm font-medium text-primary hover:underline">Về trang chính</Link>
    </div>
  )
}
